import React from "react";

/**
 * Logotipo oficial do Google Tag Manager, inline para não depender de request
 * externo. Origem: gstatic.com/analytics-suite/header/suite/v2/ic_tag_manager.svg
 * (o mesmo ícone que o Google usa no header do Analytics Suite).
 */
export const GtmLogo = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 192 192" fill="none" role="img" aria-label="Google Tag Manager">
        <polygon fill="#8AB4F8" points="111.31,176.79 80.76,147 146.37,80 178,111" />
        <path
            fill="#4285F4"
            d="M111.44,45.08L81,14L14.44,79.93c-8.58,8.58-8.58,22.49,0,31.08L80,177l31-29L61.05,95.47L111.44,45.08z"
        />
        <path
            fill="#8AB4F8"
            d="M177.56,80.44l-66-66c-8.59-8.59-22.52-8.59-31.11,0c-8.59,8.59-8.59,22.52,0,31.11l66,66c8.59,8.59,22.52,8.59,31.11,0C186.15,102.96,186.15,89.03,177.56,80.44z"
        />
        <circle fill="#246FDB" cx="95.5" cy="162.5" r="21.5" />
    </svg>
);

export default GtmLogo;
